// Provider calendar dates come as 'YYYY-MM-DD' (Realtor history) or as a UTC-midnight timestamp
// (RentCast listedDate / removedDate). `new Date()` reads either as UTC midnight, one calendar day
// early west of Greenwich, so both are built as local midnight instead. Anything else, including a
// timestamp with a real time of day, parses exactly as before.
const CALENDAR_RE = /^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.000)?Z)?$/

export function parseCalendarDate(value) {
  const m = typeof value === 'string' ? CALENDAR_RE.exec(value) : null
  if (!m) return new Date(value)
  const [year, month, day] = [Number(m[1]), Number(m[2]) - 1, Number(m[3])]
  // setFullYear, not the constructor: new Date(99, ...) means 1999. A date that does not round-trip
  // (month 13, Feb 31) falls back to new Date() so it behaves exactly as it did before this helper.
  const date = new Date(0)
  date.setFullYear(year, month, day)
  date.setHours(0, 0, 0, 0)
  if (date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day) return new Date(value)
  return date
}
